import { SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { useTheme } from "@mui/material";
import {
  MSFilterLabelSkeleton
} from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/skeletons/label";

export const MSFilterSliderSkeleton = () => {
  const { palette, shadows } = useTheme();

  return (
    <SHStack
      padding={1.5}
      bgcolor={palette.common.white}
      borderRadius={"12px"}
      boxShadow={shadows[1]}
    >
      <MSFilterLabelSkeleton />

      <SHStack
        justifyContent={"center"}
        alignItems={"center"}
        paddingX={0.5}
        position={"relative"}
        paddingY={1.5}
      >
        <SHSkeleton
          width={20}
          height={20}
          delay={false}
          sx={{
            borderRadius: "12px",
            position: "absolute",
            left: 0,
          }}
        />
        <SHSkeleton
          height={5}
          width={"calc(100% - 30px)"}
          delay={false}
          sx={{ zIndex: 1 }}
        />
        <SHSkeleton
          width={20}
          height={20}
          delay={false}
          sx={{
            borderRadius: "12px",
            position: "absolute",
            right: 0,
          }}
        />
      </SHStack>

      <SHStack
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <SHSkeleton
          width={60}
          height={30}
          delay={false}
          sx={{ borderRadius: "12px" }}
        />
        <SHSkeleton width={30} height={20} delay={false} />
        <SHSkeleton
          width={60}
          height={30}
          delay={false}
          sx={{ borderRadius: "12px" }}
        />
      </SHStack>
    </SHStack>
  );
};
